export default __webpack_public_path__ + "static/media/Hair_9_M_C4.93090fb2.svg";